import { User } from "../models/user";
import { Quicklink } from "../models/quicklink";
import { UserGroupModel } from "../models/UserGroupModel";
import { QuickLinksGroupModel } from "../models/QuickLinksGroupModel";
import { UserQuicklinkGroupMapping } from "../models/UserQuicklinkGroupMapping";
import {  ProjectLinks } from "../models/ProjectLinks";

export const mapToUser = (data: any[]): User[] => {
  return data.map((item: any) => ({
    userID: item.userID,
    tenantID: item.tenantID,
    userName: item.userName,
    firstName: item.firstName,
    lastName: item.lastName,
    Office365MailId: item.office365MailId,
    dropBoxMailId: item.dropBoxMailId,
    isActive: item.isActive,
    roleID: item.roleID,
    licenseType: item.licenseType,
    isUserLicenseRemoved: item.isUserLicenseRemoved,
    tenantLicenseID: item.tenantLicenseID,
    title: item.title,
    licenseEndDate: item.licenseEndDate,
    licenseStartDate: item.licenseStartDate,
    tenantLicenseSlotId: item.tenantLicenseSlotId,
    licenceTypeName: item.licenceTypeName,
    IsLicenseActive: item.isLicenseActive,
  }));
};

export const mapToQuickLink = (data: any[]): Quicklink[] => {
  return data.map((item: any) => ({
    quickLinkID: item.quickLinkID,
    tenantID: item.tenantID,
    name: item.name,
    description: item.description,
    URL: item.url,
    source: item.source,
    isActive: item.isActive,
    type: item.type
  }));
};

export const mapToProjectLink = (data: any[]): ProjectLinks[] => {
  return data.map((item: any) => ({
    projectLinkID: item.projectLinkID,
    tenantID: item.tenantID,
    name: item.name,
    description: item.description,
    URL: item.url,
    source: item.source,
    isActive: item.isActive,
    type: item.type,
  }));
};

export const mapToUserGroups = (data: any[]): UserGroupModel[] => {
  return data.map((item: any) => ({
    userGroupID: item.userGroupID,
    description: item.description,
    groupName: item.groupName,
    tenantID: item.tenantID,
    isActive: item.isActive,
  }));
};

export const mapToQuickLinkGroups = (data: any[]): QuickLinksGroupModel[] => {
  return data.map((item: any) => ({
    projectLinkGroupID: item.quickLinksGroupID,
    description: item.description,
    name: item.name,
    tenantID: item.tenantID,
    isActive: item.isActive,
  }));
};


export const mapToUserQuicklinkGroupMappings = (data: any[]): UserQuicklinkGroupMapping[] => {
  return data.map((item: any) => ({
    userGroupProjectLinkGroupMappingID: item.userGroupProjectLinkGroupMappingID ?? 0,
    userGroupID: item.userGroupID ?? 0,
    projectLinkGroupID: item.projectLinkGroupID ?? 0,
    name: item.name ?? "",
    description: item.description ?? "",
    isChecked: item.isChecked ?? false,
  }));
};